module.exports = __webpack_public_path__ + "static/carousel-00001-b94aba34b7561cc9c2f943518985cfd5.jpg";